const ONBOARDING_QUERY_ROOTS = new Set(['onboarding', 'onboarding-lock']);

/**
 * Foundation edits can change every workspace-derived roster and library view.
 * Keep the transition's freshly seeded onboarding state, but mark every other
 * cache carrying this workspace id stale so inactive screens refetch on mount.
 */
export function isOnboardingDependentQuery(queryKey: readonly unknown[], workspaceId: string): boolean {
  return !ONBOARDING_QUERY_ROOTS.has(String(queryKey[0] ?? '')) && queryKey.some((part) => part === workspaceId);
}
